import { solidstate } from ":setup/qstate";
import { global } from ":shared/app";
import { createEffect, createMemo, Match, Show, Switch } from "solid-js";

import { Loader2 } from ":src/components/loaders";
import { Grading, SubmissionsTable } from "./components";
import { teams, scoring } from "./apis";
import { createInput, createSelect } from ":ui/form";
import type { SubmissionStatus } from "./_model";
import GradingModal from "./components/grading-modal";

function getTitle() {
  const jwt = global.api.auth.token.decoded();
  if (jwt.user_key === "evaluator") {
    return "evaluation";
  }
  if (jwt.user_key === "judge") {
    return "judging";
  }
  if (jwt.user_key === "filterer") {
    return "nominees";
  }
  return "";
}
export default function () {
  const $details = solidstate.createAsync(teams.get);
  const title = getTitle();
  const $active_index = solidstate.create(null);
  const $applied_filter = solidstate.create({} as { search?: string; status?: SubmissionStatus });
  const $filters = createMemo(() => {
    const result = {
      // search: ["title", "category"],
      statuses: ["pending", "done"] as SubmissionStatus[],
    };
    return result;
  });
  const Search = createInput(null);
  const FilterStatus = createSelect(null);

  createEffect(() => {
    const search = Search.control.value;
    $applied_filter.set((s) => ({ ...s, search: search }));
  });
  createEffect(() => {
    const status = FilterStatus.control.value;
    $applied_filter.set((s) => ({ ...s, status: status }));
  });

  function onSwitch(props: { next: boolean }) {
    const arr_length = $details.value?.teams?.length;
    let idx = $active_index.value;
    if (props.next) {
      idx++;
      if (idx >= arr_length) idx = 0;
    } else {
      idx--;
      if (idx <= -1) idx = arr_length - 1;
    }
    $active_index.set(idx);
  }

  async function onSubmit(props: { scores: Record<string, number> }) {
    const team = $details.value?.teams?.[$active_index.value];
    const scores = props.scores;
    // await new Promise((res) => {
    //   setTimeout(() => {
    //     res(null);
    //   }, 1000);
    // });
    return scoring.postOrPut({ team, scores }).then((new_team) => {
      global.store.actions.toast.pushToast({
        type: "success",
        message: "Evaluation Submitted!",
      });
      $details.set((s) => {
        const teams = [...s.teams];
        teams[$active_index.value] = new_team;
        return { ...s, teams };
      });
    });
  }

  return (
    <section class="flex flex-col w-full h-full px-2 py-2">
      <h1 class="text-xl  font-600 text-black z-1 capitalize lt-sm:(text-22px)">{title}</h1>
      <Switch>
        <Match when={$details.state.loading}>
          <Loader2 msg="Loading Submissions..." />
        </Match>
        <Match when={$details.state.failed}>error occured while loading membres {$details.error}</Match>
        <Match when={$details.state.success}>
          {/* <Show
            when={$active_index.value == undefined}
            fallback={
              <Grading
                //
                team={$details.value?.teams?.[$active_index.value]}
                criteria={$details.value.criteria}
                onSubmit={async ({ scores }) => onSubmit({ scores })}
                onNext={() => onSwitch({ next: true })}
                onPrevious={() => onSwitch({ next: true })}
                onBack={() => $active_index.set(undefined)}
              />
            }
          >
            
          </Show> */}
          <div class="flex flex-row w-full justify-between items-center gap-2 py-2 <sm:(!flex-col !gap-x-0)">
            <Search.Input autocomplete="search" class="form-input" placeholder="Search by name..." />
            <FilterStatus.Select
              class="form-select !w-30% <sm:(!w-full)"
              placeholder="Filter By Status..."
              options={$filters().statuses}
              allowClearSelected
            />
          </div>
          <div class="flex h-full pb-5 overflow-hidden">
            <SubmissionsTable
              details={$details.value}
              filter={{ search: $applied_filter.value.search, status: $applied_filter.value.status }}
              onEvaluate={({ item, itemIndex }) => {
                // $active_index.set(itemIndex());
                const index = $details.value.teams.findIndex((s) => s.id === item.id) ?? itemIndex();
                // console.log("index :: ", itemIndex);
                global.store.actions.popop.pushModal({
                  title: "Evaluate Team",
                  startExpanded: true,
                  element(action) {
                    return (
                      <GradingModal
                        data={$details as any}
                        idx={index}
                        onSubmit={({ team, scores }) => {
                          return scoring.postOrPut({ team, scores });
                        }}
                      />
                    );
                  },
                });
              }}
            />
          </div>
        </Match>
      </Switch>
    </section>
  );
}
